export type PhysicianSpecialtyDescriptor = {
  key: number;
  value: string;
  sortOrder: number;
}

export type RelationshipToSurvivorDescriptor = {
  key: number;
  name: string;
  description: string;
  sortOrder: number;
}

export type ProviderTitleDescriptor = {
  value: string;
  sortOrder: number;
}

// Note: this must match the equivalent enum in the API: SurvivorLink.Models.Constants.AppEnums.Relationship
export const enum SurvivorLinkRole {
  Unknown = 0,
  Survivor = 1,
  Parent = 2,
  LegalGuardian = 3,
  Provider = 4,
  Other = 5
}

// Note: this must match the equivalent enum in the API: SurvivorLink.Models.HealthRecord.CustodianRelationship
export const enum HealthRecordOwnerRelationshipToSurvivor {
  Parent = 1,
  LegalGuardian = 2,
  Survivor = 3
}

export class UserConstants {
  /**********************************************************
   * If changes are made, API code must be updated to match *
   **********************************************************/

  static physicianSpecialties: PhysicianSpecialtyDescriptor[] = [
    {
      key: 101,
      value: 'Survivor Care',
      sortOrder: 0,
    },
    {
      key: 26,
      value: 'Primary Care',
      sortOrder: 1,
    },
    {
      key: 102,
      value: 'Family Medicine',
      sortOrder: 2,
    },
    {
      key: 103,
      value: 'College Health',
      sortOrder: 3,
    },
    {
      key: 64,
      value: 'Cardiology',
      sortOrder: 4,
    },
    {
      key: 105,
      value: 'Dentistry',
      sortOrder: 5,
    },
    {
      key: 106,
      value: 'Dermatology',
      sortOrder: 6,
    },
    {
      key: 63,
      value: 'Endocrinology',
      sortOrder: 7,
    },
    {
      key: 107,
      value: 'ENT',
      sortOrder: 8,
    },
    {
      key: 28,
      value: 'OB/Gyn',
      sortOrder: 9,
    },
    {
      key: 29,
      value: 'Oncology',
      sortOrder: 10,
    },
    {
      key: 108,
      value: 'Ophthalmology/Optometry',
      sortOrder: 11,
    },
    {
      key: 110,
      value: 'Orthopedics',
      sortOrder: 12,
    },
    {
      key: 104,
      value: 'Psychiatry',
      sortOrder: 13,
    },
    {
      key: 62,
      value: 'Psychology',
      sortOrder: 14,
    },
    {
      key: 109,
      value: 'Pulmonology',
      sortOrder: 15,
    },
    {
      key: 111,
      value: 'Research',
      sortOrder: 16,
    },
    {
      key: 27,
      value: 'Surgery',
      sortOrder: 17,
    },
    {
      key: 65,
      value: 'Other',
      sortOrder: 18,
    },
  ];

  static physicianPatientPopulation: {  key: string, value: string }[] = [
    {
      key: 'Adults',
      value: 'Adults',
    },
    {
      key: 'Pediatrics',
      value: 'Pediatrics',
    },
    {
      key: 'Both',
      value: 'Both',
    },
  ];

  static relationshipToSurvivor: RelationshipToSurvivorDescriptor[] = [
    {
      key: 3,
      name: 'Survivor',
      description: 'I am the Survivor',
      sortOrder: 1,
    },
    {
      key: 1,
      name: 'Parent',
      description: 'I am a Parent of the Survivor',
      sortOrder: 2,
    },
    {
      key: 2,
      name: 'Legal Guardian',
      description: 'I am a Legal Guardian of the Survivor',
      sortOrder: 3,
    },
  ];

  static relationshipToSurvivorLink: RelationshipToSurvivorDescriptor[] = [
    {
      key: 1,
      name: 'I am a Survivor',
      description: 'I am a Survivor',
      sortOrder: 1,
    },
    {
      key: 2,
      name: 'Parent of a Survivor',
      description: "I'm a Parent of a Survivor",
      sortOrder: 2,
    },
    {
      key: 3,
      name: 'Legal Guardian of a Survivor',
      description: "I'm a Legal Guardian of a Survivor",
      sortOrder: 3,
    },
    {
      key: 4,
      name: 'Healthcare Provider or Clinic Staff',
      description: "I'm a Healthcare Provider or Clinic Staff to a Survivor",
      sortOrder: 4,
    },
    {
      key: 5,
      name: 'Other',
      description: 'Other relationship to a Survivor',
      sortOrder: 5,
    },
  ];

  static providerTitles: ProviderTitleDescriptor[] = [
    {
      value: 'MD',
      sortOrder: 0,
    },
    {
      value: 'DO',
      sortOrder: 1,
    },
    {
      value: 'PhD',
      sortOrder: 2,
    },
    {
      value: 'PsyD',
      sortOrder: 3,
    },
    {
      value: 'DDS',
      sortOrder: 4,
    },
    {
      value: 'NP',
      sortOrder: 5,
    },
    {
      value: 'PA',
      sortOrder: 6,
    },
    {
      value: 'RN',
      sortOrder: 7,
    },
    {
      value: 'LPN',
      sortOrder: 8,
    },
    {
      value: 'MA',
      sortOrder: 9,
    },
    {
      value: 'SW',
      sortOrder: 10,
    },
    {
      value: 'Researcher',
      sortOrder: 11,
    },
    {
      value: 'Administrator',
      sortOrder: 12,
    },
    {
      value: 'Student/Trainee',
      sortOrder: 13,
    },
    {
      value: 'Other',
      sortOrder: 18,
    },
  ];
}
